/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    UpdateCropForcasting,
    GetProductCategoties,
    GetProductTypes,
    GetFactoriesByGroupID,
    GetRouteByFactoryID,
    GetCollectorDetailsByFactoryIDRouteID,
    GetCollectorCropMappingDetailsByProductIDFarmerID,
    GetAllProductVarietyByProductID,
    GetProductsByFactoryIDProductcatogeryID,
    AddCollectorCropForcasting,
    UpdateCollectorCropForcasting,
    RemoveCollectorCropForcasting
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRouteByFactoryID(factoryID) {
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + parseInt(factoryID));
    return response.data;
}

async function GetCollectorDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetCollectorDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetCollectorCropMappingDetailsByProductIDFarmerID(operationEntityID, productID, farmerID, date) {
    const response = await CommonGet('/api/CropForcasting/GetCollectorCropMappingDetailsByProductIDFarmerID',
        'operationEntityID=' + parseInt(operationEntityID) + '&productID=' + parseInt(productID) + '&farmerID=' + parseInt(farmerID) + '&date=' + date);
    return response.data;
}

async function UpdateCropForcasting(values) {
    const response = await CommonPost('/api/CropForcasting/UpdateCropForcasting', null, values);
    return response;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + productID);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function AddCollectorCropForcasting(values) {
    const response = await CommonPost('/api/CropForcasting/AddCollectorCropForcasting', null, values);
    return response;
}

async function UpdateCollectorCropForcasting(values) {
    const response = await CommonPost('/api/CropForcasting/UpdateCollectorCropForcasting', null, values);
    return response;
}

async function RemoveCollectorCropForcasting(cropForecastDetailID, createdBy) {
    const response = await CommonGet('/api/CropForcasting/RemoveCollectorCropForcasting', 'cropForecastDetailID=' + parseInt(cropForecastDetailID) + '&createdBy=' + parseInt(createdBy));
    return response;
}
